import React, { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { QuizHeaderProps } from '~/core/dto/components/quizHeaderDTO';
import { NavigationPath } from '~/core/dto/navigationDTO';
import arrow from '~/assets/icons/Arrow.svg';

import './QuizHeader.styles.css';
import Spacer from '../Spacer';

const QuizHeader: FC<QuizHeaderProps> = ( { progress = 0, onlyTitle = false, type } ) => {

  const navigate = useNavigate();

  return (
    <div className="quizHeaderContainer flexColumn justifySpaceBetween alignCenter">
      <div className="quizHeader flexRow justifyCenter alignCenter">
        {!onlyTitle && (
        <div className="back flexRow alignCenter justifyCenter cursorPointer" onClick={() => navigate( -1 )} aria-hidden>
          <Spacer size={8} horizontal />
          <img src={arrow} alt="Back" />
          <p>back</p>
          <Spacer size={8} horizontal />
        </div>
        )}
        <Link to={type === 'adult' ? NavigationPath.AdultHome : NavigationPath.Home} className="birdwingoTitle">BIRDWINGO</Link>
      </div>
      {!onlyTitle && (
      <div className="progressBar">
        <div className="progressBarFill" style={{ width: `${Math.round( progress * 100 )}%` }} />
      </div>
      )}
    </div>
  );

};

export default QuizHeader;
